import React, { useEffect, useState } from 'react';
import { Button, Form, Input, InputNumber } from 'antd';

const initForm = {
    name: '',
    value: 10,
    color: '#cccccc',
};

export const FormTag = ({ loading = false, formData, onFinish }) => {
    const [form] = Form.useForm();
    const [colorInput, setColorInput] = useState(initForm.color);

    useEffect(() => {
        const formValues = formData ? formData : initForm;
        setColorInput(formValues.color);
        form.setFieldsValue(formValues);
    }, [formData, form]);

    const handleColorChange = (e) => {
        const newColor = e.target.value;
        setColorInput(newColor);
    };

    return (
        <Form
            form={form}
            layout="vertical"
            className="w-full"
            onFinish={() => {
                onFinish({ ...form.getFieldsValue(), color: colorInput })
            }}
        >
            <Form.Item
                name="name"
                label="Nombre"
                rules={[
                    {
                        required: true,
                        message: 'Necesita un nombre!!',
                        whitespace: true,
                    },
                ]}
                className='mb-2'
            >
                <Input />
            </Form.Item>

            <label className='flex flex-col gap-2 mb-2' htmlFor="color">
                <p>Color</p>
                <input
                    name='color'
                    type="color"
                    className="w-6 h-[26px] bg-transparent px-[1px] border border-[#E6E6E6] rounded-md"
                    value={colorInput}
                    onChange={handleColorChange}
                />
            </label>

            <Form.Item
                name="value"
                label="Order"
                rules={[
                    {
                        required: true,
                        message: 'Necesita un número!!',
                    },
                ]}
            >
                <InputNumber min={0} />
            </Form.Item>

            <Form.Item className="w-full flex justify-end m-0 mt-4">
                <Button type="primary" htmlType="submit" loading={loading}>
                    Guardar
                </Button>
            </Form.Item>
        </Form>
    );
};
